module.exports = __webpack_public_path__ + "img/dwn_resume_red.b4afb74e.svg";